/* eslint-disable jsx-a11y/control-has-associated-label */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faRotate } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import AssetsIcon from "../../../assets/icons/asset-01.svg2";
import HelpButton from "../../HelpContent/HelpButton";

export default function MonitoringWidget() {
  return (
    <div className="position-relative px-2 d-flex flex-column h-100">
      <div className="d-flex p-3 pb-1 align-items-center ">
        <AssetsIcon width={20} className="white opacity-50" />{" "}
        <Link className="btn p-0 text-white" to="/monitoring">
          <h6 className="m-0 mx-2 small fw-bold">MONITORING</h6>
        </Link>
        <button
          className="btn p-0 text-white ms-2"
          onClick={() => window.location.reload()}
          title="Refresh monitoring data"
        >
          <FontAwesomeIcon icon={faRotate} className="opacity-50" />
        </button>
        <HelpButton helpKey="widgets-monitoring" iconClassName="white" />{" "}
        <FontAwesomeIcon
          icon={faGripVertical}
          className="ms-4 opacity-50 widget-header"
        />
      </div>
      <div className="">
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 opacity-50">Number of Monitors</span>
          <h3 className="fw-bold m-0 p-1">{10}</h3>
        </div>
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Active monitors</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">When was active</span>
          <h3 className="fw-bold m-0 p-1 small">{12.45}</h3>
        </div>{" "}
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">
            How long was active
          </span>
          <h3 className="fw-bold m-0 p-1 small">20 mins</h3>
        </div>
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 opacity-50">Assets being monitored</span>
          <h3 className="fw-bold m-0 p-1">{3}</h3>
        </div>
        <hr className="m-1" />
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Vehicle</span>
          <h3 className="fw-bold m-0 p-1 small">{2}</h3>
        </div>
        <div className="d-flex justify-content-between px-3">
          <span className="fw-bold p-1 small opacity-50">Human</span>
          <h3 className="fw-bold m-0 p-1 small">{1}</h3>
        </div>{" "}
      </div>
      <div className="flex-grow-1" />
    </div>
  );
}
